// src/routes.tsx
import React from "react";

// Admin Pages
import MainDashboard from "views/dashboard";
import EventosPage from "views/eventos";
import DataTables from "views/jugadores";

// Auth Page
import SignIn from "views/auth/SignIn";

// Icon Imports
import { MdHome, MdLock } from "react-icons/md";
import { GiSoccerField, GiSoccerKick } from "react-icons/gi";

export interface RoutesType {
  name: string;
  /** Bajada del encabezado de página. Sólo presentación. */
  description?: string;
  path: string; // e.g. "", "eventos", "inicio-sesion"
  icon: React.ReactElement;
  component: React.ReactElement;
  secondary?: boolean;
}

const routes: RoutesType[] = [
  {
    name: "Panel Principal",
    description:
      "Resumen de la temporada: asistencias, eventos y actividad del plantel.",
    path: "", // <== empty => will become the "/" page
    icon: <MdHome className="h-[18px] w-[18px]" />,
    component: <MainDashboard />,
  },
  {
    name: "Eventos",
    description:
      "Creá partidos y peñas, y registrá quién asistió a cada uno.",
    path: "eventos", // => "/eventos"
    icon: <GiSoccerField className="h-[18px] w-[18px]" />,
    component: <EventosPage />,
    secondary: true,
  },
  {
    name: "Jugadores",
    description: "Plantel activo e inactivo del club.",
    path: "jugadores", // => "/jugadores"
    icon: <GiSoccerKick className="h-[18px] w-[18px]" />,
    component: <DataTables />,
  },
  {
    name: "Iniciar Sesión",
    path: "inicio-sesion", // => "/inicio-sesion"
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <SignIn />,
  },
];

export default routes;
